import React from "react";
import Representation from './Representation';

const MultiSelect = (props) => {
  return <Representation
    {...props}
  />
}

export default MultiSelect;